export default __webpack_public_path__ + "static/media/BM_RenderCamera_20_CU_B+Interior+Detail+Hallway.abab71e5.jpg";